import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, openBlock as _openBlock, createBlock as _createBlock } from "vue"

const _hoisted_1 = { class: "text-left" }
const _hoisted_2 = { class: "text-left" }
const _hoisted_3 = { class: "text-left" }
const _hoisted_4 = { class: "text-left" }
const _hoisted_5 = { class: "text-right" }
const _hoisted_6 = { class: "text-right" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_oss_data_table = _resolveComponent("oss-data-table")!
  const _component_v_col = _resolveComponent("v-col")!
  const _component_v_row = _resolveComponent("v-row")!

  return (_openBlock(), _createBlock(_component_v_row, null, {
    default: _withCtx(() => [
      _createVNode(_component_v_col, { cols: "12" }, {
        default: _withCtx(() => [
          _createVNode(_component_oss_data_table, {
            headers: _ctx.headers,
            items: _ctx.companyBuildings,
            class: "table elevation-0",
            "fixed-header": "",
            "items-per-page": -1,
            "hide-default-footer": "",
            density: "compact"
          }, {
            "item.default": _withCtx(({ props }) => [
              _createElementVNode("tr", null, [
                _createElementVNode("td", _hoisted_1, _toDisplayString(_ctx.formatDate(props.item.acquiredDate)), 1),
                _createElementVNode("td", _hoisted_2, _toDisplayString(props.item.natureA), 1),
                _createElementVNode("td", _hoisted_3, _toDisplayString(props.item.name), 1),
                _createElementVNode("td", _hoisted_4, _toDisplayString(props.item.address), 1),
                _createElementVNode("td", _hoisted_5, _toDisplayString(props.item.city), 1),
                _createElementVNode("td", _hoisted_6, _toDisplayString(props.item.country), 1)
              ])
            ]),
            _: 1
          }, 8, ["headers", "items"])
        ]),
        _: 1
      })
    ]),
    _: 1
  }))
}